export interface HelicopterPackage {
  id: string;
  name: string;
  duration: string;
  price: number;
  priceLabel: string;
  capacity: string;
  isPrivateOnly?: boolean;
  isBestValue?: boolean;
  locations: string[];
}

export interface HelicopterBookingFormData {
  packageId: string;
  guests: number;
  date: Date;
}

export const HELICOPTER_PACKAGES: HelicopterPackage[] = [
  {
    id: 'skyline-express',
    name: 'Skyline Express',
    duration: '12 Minutes',
    price: 715,
    priceLabel: 'Per Person',
    capacity: 'Shared Flight Experience',
    locations: [
      'Burj Khalifa (World\'s most iconic tower)',
      'Burj Al Arab',
      'Dubai Coastline',
      'The Palm Jumeirah',
      'Other famous landmarks of Dubai'
    ]
  },
  {
    id: 'iconic-dubai',
    name: 'Iconic Dubai Flight',
    duration: '17 Minutes',
    price: 979,
    priceLabel: 'Per Person',
    capacity: 'Shared Flight Experience',
    isBestValue: true,
    locations: [
      'Atlantis, The Palm',
      'Burj Al Arab Hotel',
      'Burj Khalifa',
      'Dubai Coastline',
      'Downtown Dubai',
      'Business Bay',
      'Lagoon Project (Upcoming, biggest swimming pool in the world)'
    ]
  },
  {
    id: 'ultimate-city',
    name: 'Ultimate City Tour',
    duration: '25 Minutes',
    price: 1450,
    priceLabel: 'Per Person',
    capacity: 'Shared Flight Experience',
    locations: [
      'Arabian Gulf',
      'The World Island',
      'Burj Khalifa (World\'s tallest building)',
      'Skyscrapers of Sheikh Zayed Road',
      'Dubai Creek (Historical heritage architecture)',
      'Port Rashid',
      'Jumeirah Beach Coastline',
      'Dubai Internet City',
      'Jebel Ali Race Course',
      'Jumeirah Lake Towers',
      'Dubai Marina'
    ]
  },
  {
    id: 'grand-explorer',
    name: 'Grand Dubai Explorer',
    duration: '60 Minutes',
    price: 15593,
    priceLabel: 'Private Flight',
    capacity: 'Private Flight for up to 5 people',
    isPrivateOnly: true,
    locations: [
      'The Palm Jumeirah',
      'The World Islands',
      'Burj Al Arab',
      'Jumeirah Bay Island',
      'Kite Beach',
      'Al Safa Park',
      'Dubai Canal Project',
      'Burj Khalifa',
      'Sheikh Zayed Road',
      'Port Rashid',
      'Dubai Creek',
      'Wafi Mall',
      'Dubai Frame',
      'Zabeel Park',
      'Mall of Emirates',
      'Jebel Ali Race Course',
      'Dubai Marina',
      'Emirates Golf Club',
      'The Montgomerie Dubai',
      'Port of Jebel Ali',
      'The Palm, Jebel Ali'
    ]
  }
];
